import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { is, or } from "@amcharts/amcharts4/core";
import { order } from "@amcharts/amcharts4/.internal/core/utils/Number";

declare var ko: any;

export class ideationSourceList_template extends vnTemplate {


    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {
        return /*html*/`
                <div class="list-header w-justify" >

                    <div class="w-left">
                        <button data-bind="click: function() { onClickShowPopUp('add') }" class="btn secondary icon i-add" type="button">Add Source</button>
                        <button data-bind="click: onClickTopicsList" class="btn secondary icon i-article" type="button">Go To Topic List</button>
                    </div>

                    <div class="w-center">
                        ${this.filter.getHtmlBuild()}
                    </div>

                    <div class="w-right">
                        ${this.pagination.getHtmlBuild()}
                    </div>
                </div>


                <div class="w-list-results" id="list-results">
                    <table class="list-results">
                        ${this.resultInfos.getHtmlBuild()}
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                                <th><span>Delete</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: sources">
                            <tr class="cursor">
                                <td data-bind="event: { click: $parent.onClickEditSource }"><a class="right-click"><span data-bind="text: name"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditSource }"><a class="right-click"><span data-bind="text: dateCreated"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditSource }"><a class="right-click"><span data-bind="text: dateUpdated"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditSource } " class="align-right"><button type="button" data-bind="event: { click: $parent.onClickShowDeletePopUp }, clickBubble: false" class="btn border only-icon icon i-delete"></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="w-lightbox light-theme" data-bind="css: { 'is-visible' : isVisible }">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title" data-bind="text: popupAction() + ' Source'"></h3>
                                <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <label class="form-label">Name</label>
                                    <div class="w-input">
                                        <input type="text" name="name" id="name"  class="input-text" data-bind="value: selectedSource().name">
                                    </div>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickCancel }" class="btn border only-icon icon">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickSave }" class="btn border only-icon icon">Save</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div id="delete-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Deleting source</h3>
                                <button type="button"  data-bind="event: { click: onClickHideDeletePopUp }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">This action is irreversible</p>
                                    <p class="form-text">Are you sure you want to delete this source :

                                        <p data-bind=" if: idSourceToDelete() !== null ">
                                        <span data-bind="text: idSourceToDelete().name"></span>
                                        </p>

                                    </p>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickHideDeletePopUp }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                            </div>
                        </div>

                    </div>
                </div>


         `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

    }

    protected getTemplateName(): string {
        return "ideationSourceList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            sources: ko.observableArray([]),
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            isVisible: ko.observable(false),
            showParentName: ko.observable(false),
            popupAction: ko.observable("add"),
            idSourceToDelete: ko.observable(null),
            selectedSource: ko.observable({
                id: null,
                name: '',
                isDeleted: 0,
                dateCreated: null,
                dateUpdated: null
            }),
            onClickEditSource: function (data, event) {
                var source = self.getTemplateViewModel().sources().find(source => source.id === data.id);
                self.getTemplateViewModel().selectedSource({
                    ...source,
                    isDeleted: source.isDeleted === true ? 1 : 0
                });
                self.onClickShowPopUp('edit');
            },
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickShowPopUp: function (value, data, event) {
                self.onClickShowPopUp(value)
            },
            onClickShowDeletePopUp: function (value, data, event) {
                self.onClickShowDeletePopUp(value)
            },
             onClickHideDeletePopUp: function (value, data, event) {
                self.onClickHideDeletePopUp()
            },
            onClickCancel: function (value, data, event) {
                self.onClickCancel()
            },
            onClickSave: function (value, data, event) {
                self.onClickSave()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            },
            onClickTopicsList: function (value, data, event) {
                self.onClickTopicsList()
            }
        }
    }


    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection(),
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword(),
            }
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);

        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.sourcesListReorder();
    }

    public setSources(sources) {

        this.getTemplateViewModel().sources(sources);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickShowPopUp(action) {
        if (action === 'add') {
            this.getTemplateViewModel().selectedSource({
                id: null,
                name: '',
                isDeleted: 0,
                dateCreated: null,
                dateUpdated: null
            });
        }

        this.getTemplateViewModel().popupAction(action);
        this.getTemplateViewModel().isVisible(true);
    }

    public onClickHideDeletePopUp(): any {
        this.getTemplateViewModel().idSourceToDelete(null);
        this.toggleDeleteDialogVisibility()
    }
    public onClickShowDeletePopUp(data): any {

        this.getTemplateViewModel().idSourceToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    public onClickCancel() {
        this.getTemplateViewModel().isVisible(false);
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }


    public onClickSave() {

        this.getTemplateViewModel().isVisible(false);
        this.caller.saveSource(this.getTemplateViewModel().selectedSource());
    }

    public onClickDelete() {
        let source_id = this.getTemplateViewModel().idSourceToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteSource(source_id);
    }

    public onClickTopicsList() {

        this.caller.redirectToTopicsList();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/ideationSourceList_template.ts